<div class="modal-header">
  <button mat-icon-button class="close-button" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<app-document-upload></app-document-upload>